<template>
  <el-container >
    <el-header style="height: 50px;width:100%; padding: 0px; position: fixed;  top: 0;">
      <div style="background-color: #000000; height: 50px; line-height: 50px;">
        <el-row>
          <el-col :span="12">
            <img src="../../static/images/logo_up.png" style="width: 66%; margin-left: 30px; vertical-align: middle;">
          </el-col>
          <el-col  :span="12" style="text-align: right;">
            <img @click="drawer = true" src="../../static/images/menu.png" style="width: 30px;height: 30px;vertical-align: middle; margin-right: 10px;">
          </el-col>
        </el-row>
      </div>
    </el-header>
    <el-main>
      <div class="start" id="topAnchor">
        <div style="margin-top: 20px">
          <img src="../../static/images/banner_content.png" style="width: 100%">
        </div>


        <div style="margin-top: 40px;">
          <span style="font-size: 18px;
                     font-weight: 200;
                     color: #FFFFFF;">秉承“求真、透明”的投研原则</span><br/>
          <span style="font-size: 18px;
                     font-weight: 200;
                     color: #FFFFFF;">“诚信、专业”的经营理念</span>
        </div>
        <div style="margin-top: 60px; margin-bottom: 20px;">
          <span style="font-size: 12px;
                  font-weight: 200;
                  color: #FFFFFF;
                  margin-top: 40px;">开展资产管理业务，以数理统计、深度学习为理论基础，专注于全球资本市场策略研发，策略覆盖量化选股、指数增强、中性对冲、CTA、FOF等策略。
        </span>
        </div>


      </div>
      <div style="padding: 40px 30px;" id="about">
        <div style="height: 20px;"></div>
        <img class="logo" src="../../static/images/about.png"><br>
        <p style="color: #333333;font-size: 14px;">信弘天禾创立于2012年10月，于2015年取得私募基金管理人资质，2021年入驻北京基金小镇，具备投顾资质。</p>
        <p style="color: #333333;font-size: 14px;">信弘天禾秉承“求真、透明”的投研原则，“诚信、专业”的经营理念，开展资产管理业务，以数理统计、深度学习为理论基础，专注于全球资本市场策略研发，策略覆盖量化选股、指数增强、中性对冲、CTA、FOF等策略。</p>
        <p style="color: #333333;font-size: 14px;">公司设有上海、北京两地办公室，多次荣获金牛奖、金长江奖、朝阳永续私募风云榜、东方财富私募风云榜、私募排排网、介甫奖等行业荣誉。</p>
        <img  src="../../static/images/about1.png" style="width: 100%">
      </div>

      <div style="background: #F6F6F6;" id="stock">
        <div style="padding: 40px 30px;">
          <img class="logo" src="../../static/images/stock.png"/>
          <div style="padding: 14px 0px;">
            <span class="title">量化选股</span> <span style="font-size: 12px;color: #787878;">/ Long-only Strategy</span><br/>
            <div class="solid">全市场选股，覆盖全行业，分散个股占比，以构建收益风险比最优的股票投资组合为策略目标。</div>
          </div>
          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;">
            <span class="title">指数增强</span> <span style="font-size: 12px;color: #787878;">/ Index Enhanced Strategy</span><br/>
            <div class="solid">全市场选股，根据标的指数的风格特点构建相应的股票投资组合，以超额部分的收益风险比最优为策略目标。</div>
          </div>
          <div style="padding-top: 14px; border-top: 1px solid #CCCCCC;">
            <span class="title">中性对冲</span> <span style="font-size: 12px;color: #787878;">/ Equity Market Neutral Strategy</span><br/>
            <div class="solid">通过构建股票投资组合，同时选择相应的做空工具进行风险对冲，以实现稳健的投资收益。</div>
          </div>
        </div>
      </div>
      <div style="padding: 40px 30px;" id="futures">
        <img  class="logo" src="../../static/images/futures.png"/>
        <div style="padding: 14px 0px;">
          <span class="title" >截面型CTA</span> <span style="font-size: 12px;color: #787878;">/ Cross-section CTA</span><br/>
          <div class="solid">根据各类期货品种、板块历史数据的相关性，分析其多空信号的相对关系，构建策略组合，以追求绝对收益。</div>
        </div>
        <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;">
          <span class="title">时序型CTA</span><span style="font-size: 12px;color: #787878;"> / Time- series CTA</span><br/>
          <div class="solid">结合多种周期、多类趋势策略，分析各类期货品种的多空信号，构建策略组合，以追求绝对收益。</div>
        </div>
        <div style="padding-top: 14px; border-top: 1px solid #CCCCCC;">
          <span class="title">量化基本面CTA</span><span style="font-size: 12px;color: #787878;"> / Quantitative Fundamental CTA </span><br/>
          <div class="solid">以基本面信息为基础，利用量化的方式进行数据处理和分析，构建各类期货品种的多空信号，构建策略组合，以追求绝对收益。</div>
        </div>
      </div>
      <div style="background: #F6F6F6" id="fof">
        <div style="padding: 40px 30px;">
          <img  class="logo" src="../../static/images/fof.png"/>
          <div style="padding: 14px 0px;">
            <span class="title">混合类策略</span> <span style="font-size: 12px;color: #787878;">/ Multiple Strategy</span><br/>
            <div class="solid">股票策略叠加CTA以及其他衍生品策略。利用多种模型、不同交易资产的低相关性构建投资组合，以对冲单类资产的短期波动风险，以追求收益风险比最优的投资组合。</div>
          </div>
          <div style="padding-top: 14px; border-top: 1px solid #CCCCCC;">
            <span class="title">FOF策略</span><span style="font-size: 12px;color: #787878;"> / Fund of Funds</span><br/>
            <div class="solid">坚持自上而下的大类资产配置策略，以全天候策略为主打，量化策略为基础。坚持多周期、多资产、多策略的分散投资理念，通过平衡分配不同资产类别，实现投资组合资产优化配置和风险分散，为投资人创造长期稳定的绝对收益。</div>
          </div>
        </div>
      </div>
      <div  class="philosophy" style="padding: 40px 30px;" id="philosophy">
        <div style="width: 100%; text-align: center">
          <img  src="../../static/images/philosophy.png" style="height: 42px;"/>
        </div>
        <p><span style="color: #8FCBFE; font-size: 16px;" >独立</span> <span style="font-size: 12px;color: #FFFFFF;">/ INDEPENDENT</span> <br>
        <span style="color: #FFFFFF; font-size: 12px;">独特的思考模式、策略组合与同类基金相关性低</span></p>
        <p><span style="color: #8FCBFE; font-size: 16px;">简约</span> <span style="font-size: 12px;color: #FFFFFF;">/ CONCISE</span> <br>
        <span style="color: #FFFFFF; font-size: 12px;">追求简约的科学方法，避免不必要的模型复杂度</span></p>
        <p><span style="color: #8FCBFE; font-size: 16px;">思辨</span> <span style="font-size: 12px;color: #FFFFFF;">/ CRITICAL</span><br>
        <span style="color: #FFFFFF; font-size: 12px;">尊重技术，更强调策略背后的运算或经济原理</span></p>
        <p><span style="color: #8FCBFE; font-size: 16px;">分散</span><span style="font-size: 12px;color: #FFFFFF;"> / DIVERSIFIED</span><br>
          <span style="color: #FFFFFF; font-size: 12px;">强调策略的多样性和策略思想之间的独立性</span></p>
      </div>
      <div style="padding: 40px 30px;">
        <img style="margin-top: 20px;" class="logo" src="../../static/images/team.png">
        <div style="color: #333333;font-size: 12px; margin-top: 16px;"> 核心成员毕业于清华、北大、复旦、交大、中科大、浙大、Wharton、Cambridge、USYD、CMU、Columbia、Stanford等国内外知名院校，斩获国内外奥数、物理、算法竞赛和多类建模比赛等各项荣誉，具有全球多地区金融从业经历，拥有十年以上投资管理经验。</div>
        <img src="../../static/images/team_group.png" style="width: 100%;margin-top: 16px;">
      </div>


      <div style="background: #F6F6F6;" id="join">
        <div style="padding: 40px 30px 0px 30px;" >
          <img class="logo" src="../../static/images/join.png">
        </div>
        <div style="padding: 0px 30px 20px 30px;">
          <div style="padding: 14px 0px;text-align: justify;">
            <span class="title">算法研究员</span> <span style="color: #787878;font-size: 12px;"> 上海</span>
            <div style="margin-top: 10px;">
            <span style="font-size: 12px; color: #333333;">职责描述：<br/>
            1、负责模型训练。结合公司业务需求进行科学、合理、规范的训练、部署、实验等工作，提高模型落地效率；<br/>
            2、结合公司应用场景，深度优化如数据加载、推理效率、训练调度等针对性的技术问题；<br/>
            任职要求：<br/>
            1、国内外知名院校全日制硕士及以上学历毕业，计算机、电子、自动化等相关专业；<br/>
            2、精通C++/Python；有扎实的算法基础，精通常见的深度学习、机器学习、强化学习等算法；<br/>
            3、具有量化私募机构深度学习算法框架开发经验者；有发表国际顶会、期刊论文者优先（包括但不限于NIPS, ICML, CVPR, COLT)。<br/>
            </span>
            </div>

          </div>
          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;text-align: justify;">
            <span class="title">量化研究员</span> <span style="color: #787878;font-size: 12px;">上海</span>
            <div style="margin-top: 10px;">
            <span style="font-size: 12px; color: #333333;">职责描述：<br/>
            股票、期货、期权及其它衍生品策略研发，因子挖掘。<br/>
            任职要求：<br/>
            1、国内外知名院校全日制硕士及以上学历毕业，数学或统计、计算机、电子信息工程、物理等相关专业毕业，具有量化策略工作经验者、机器学习工作经验者优先。<br/>
            2、有较强的逻辑思维能力、数据处理能力，善于独立思考和分析判断；善于沟通，具备团队合作意识，能承受一定的工作强度。精通python、C++至少一门编程语言优先考虑。<br/>
            3、已具备高频量化相关工作经验、较强韧性者优先。<br/>
            </span>
            </div>
          </div>

          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;text-align: justify;">
            <span class="title">量化研究员（应届/实习生）</span> <span style="color: #787878;font-size: 12px;">上海</span>
            <div style="margin-top: 10px;">
            <span style="font-size: 12px; color: #333333;">职责描述：<br/>
            股票、期货及其它衍生品策略研发，因子挖掘。<br/>
            任职要求：<br/>
            1、2027/2028年国内外知名院校全日制硕士及以上学历毕业，数学或统计、计算机、电子信息工程、物理等相关专业毕业，具有量化策略工作经验者、机器学习工作经验者优先。精通python、C++至少一门编程语言优先考虑。<br/>
            2、有较强的逻辑思维能力、数据处理能力，善于独立思考和分析判断；善于沟通，具备团队合作意识，能承受一定的工作强度。<br/>
            3、毕业前可以实习6个月，已具备量化实习经验、较强韧性者优先。<br/>
            </span>
            </div>
          </div>

          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;text-align: justify;">
            <span class="title">算法研究员（应届/实习生）</span> <span style="color: #787878;font-size: 12px;">上海</span>
            <div style="margin-top: 10px;">
              <span style="font-size: 12px; color: #333333;">职责描述：<br/>
              1、负责模型训练。结合公司业务需求进行科学、合理、规范的训练、部署、实验等工作，提高模型落地效率；<br/>
              2、结合公司应用场景，深度优化如数据加载、推理效率、训练调度等针对性的技术问题；<br/>
              任职要求：<br/>
              1、2027/2028国内外知名院校全日制硕士及以上学历毕业，计算机、电子、自动化等相关专业；精通C++/Python；<br/>
              2、有扎实的算法基础，精通常见的深度学习、机器学习、强化学习等算法；<br/>
              3、毕业前可以实习3个月，有深度学习算法框架开发经验者优先；有发表国际顶会、期刊论文者优先（包括但不限于NIPS, ICML, CVPR, COLT)；<br/>
              </span>
           </div>
          </div>

          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;text-align: justify;">
            <span class="title">机器学习研究员（应届/实习生）</span> <span style="color: #787878;font-size: 12px;">上海</span>
            <div style="margin-top: 10px;">
              <span style="font-size: 12px; color: #333333;">职责描述：<br/>
              1、设计并实现适用于量化交易的机器学习/深度学习模型，包括信号建模、label构建、训练与验证流程。<br/>
              2、根据交易策略需求，优化模型结构、数据预处理和训练方法，提高信号的稳定性与预测能力。<br/>
              3、对模型输出进行信号分析和效果评估，结合回测框架进行验证与优化。<br/>
              4、与策略、技术团队紧密合作，将研究成果转化为实际可用的交易策略。<br/>
              任职要求：<br/>
              1、2026/2027国内外知名院校全日制硕士及以上学历毕业，计算机、电子、自动化等相关专业；精通C++/Python；<br/>
              2、有扎实的算法基础，精通常见的深度学习、机器学习、强化学习等算法；<br/>
              3、毕业前可以实习3个月，有深度学习算法框架开发经验者优先；有发表国际顶会、期刊论文者优先（包括但不限于NIPS, ICML, CVPR, COLT)；<br/>
              </span>
            </div>
          </div>

          <div style="padding: 14px 0px; border-top: 1px solid #CCCCCC;text-align: justify;">
            <span class="title">量化开发工程师（应届/实习生）</span> <span style="color: #787878;font-size: 12px;">上海</span>
            <div style="margin-top: 10px;">
              <span style="font-size: 12px; color: #333333;">职责描述：<br/>
              1、参与交易平台的设计、研发、测试、上线和维护；<br/>
              2、参与数据平台的设计、研发、测试和维护；<br/>
              3、参与策略平台的设计、研发、测试和维护；<br/>
              4、与量化、算法研究人员沟通，获取策略需求，负责设计方案以及落地上线收益。<br/>
              任职要求：<br/>
              1、2027/2028年国内外知名院校全日制本科以上学历毕业，计算机、软件及通信相关专业；<br/>
              2、良好的编程习惯，有效的沟通方法和快速学习能力；<br/>
              3、扎实的 C++(＞C++11)&Python基础，熟练掌握 Linux 的基本命令等；<br/>
              4、掌握计算机体系结构、网络协议、数据库、分布式计算等知识体系；<br/>
              5、对超低延时通信、多线程进程调优、机器学习等技术优化有浓烈兴趣；<br/>
              6、毕业前可以实习6个月，已具备量化实习经验、较强韧性者优先。<br/>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 40px 30px 10px 30px;">
        <img src="../../static/images/join_sup.png" style="width: 100%">
      </div>
      <div style="padding: 4px 30px 10px 30px;">
        <span style="color: #333333;font-size: 12px;">上海地址：上海市浦东新区世纪大道长泰国际金融大厦1001室 <br/>
          北京地址：北京市东城区王府井大街45号院1号楼10层1003-1004<br/>
          邮箱投递通道：<a style="color: #333333;font-size: 12px;" href="mailto:joinus@x-asset.com"> joinus@x-asset.com</a> <br/>
          投资者服务通道：<a style="color: #333333;font-size: 12px;" href="mailto:service@x-asset.com"> service@x-asset.com</a> <br/>
          联系电话：010-65008508
        </span>
      </div>
      <div style="padding: 0px 30px 30px 30px;">
        <el-row :gutter="0" >
          <el-col :span="12" style="text-align: center;">
            <img src="../../static/images/resume.png">
          </el-col>
          <el-col :span="12" style="text-align: center;">
            <img src="../../static/images/public.png">
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12" style="text-align: center;">
            <span style="font-size: 12px; color: #333333;">HR微信投递通道</span>
          </el-col>
          <el-col :span="12" style="text-align: center;">
            <span style="font-size: 12px; color: #333333;">微信公众号二维码</span>
          </el-col>
        </el-row>
      </div>
      <div class="end">
        <img src="../../static/images/end.png" style="margin-top: 120px;width: 222px;"><br>
        <img src="../../static/images/logo.png" style=" margin-top:20px;width: 42px;">

      </div>
      <div style="background: #000000; height: 30px;line-height: 30px; text-align: center">
        <span style="color: #ffffff;font-size: 12px;font-weight: 400;cursor: pointer;" @click="copyClick">京ICP备18026561号-2</span>
      </div>
    </el-main>


    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="40%">
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#topAnchor')" >首页</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#about')">关于信弘</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#stock')">股票类策略</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#futures')">期货类策略</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#fof')">混合类/FOF策略</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#philosophy')">投资理念</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="tabClk('#join')">加入信弘</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="toPiLouPage">信息披露</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="drawer_line">
        <el-col :span="20">
          <a @click="login">登录</a>
        </el-col>
        <el-col :span="4">
          <i class="el-icon-arrow-right"></i>
        </el-col>
      </el-row>
    </el-drawer>
    <el-dialog :visible.sync="centerDialogVisible"
               width="80%"
               :showClose="false">
        <span style="font-size:10px; color:#333333; height: 30px;">
          <b>一.合格投资者认证，点击官网后需要进行认证后才可浏览</b><br>
          合格投资者认证<br>
          在继续浏览本公司网站前，请您确认您或您所代表的机构是一名“合格投资者”。“合格投资者”指根据任何国家和地区的证券和投资法规所规定的有资格投资于私募证券投资基金的专业投资者。例如根据我国《私募投资基金监督管理暂行办法》的规定，合格投资者的标准如下：
          一、具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元且符合下列相关标准的单位和个人：<br>
          1、净资产不低于1000万元的单位；<br>
          2、金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人。前款所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。<br>
          <b>二、下列投资者视为合格投资者:</b><br/>
          1、社会保障基金、企业年金等养老基金，慈善基金等社会公益基金；<br>
          2、依法设立并在基金业协会备案的投资计划；<br>
          3、投资于所管理私募基金的私募基金管理人及其从业人员；<br>
          4、中国证监会规定的其他投资者。<br>
          如果您继续访问或使用本网站及其所载资料，即表明您声明及保证您或您所代表的机构为“合格投资者”，并将遵守对您适用的司法区域的有关法律及法规，同意并接受以下条款及相关约束。如果您不符合“合格投资者”标准或不同意下列条款及相关约束，请勿继续访问或使用本网站及其所载信息及资料。<br>
          投资涉及风险，投资者应详细审阅产品的发售文件以获取进一步资料，了解有关投资所涉及的风险因素，并寻求适当的专业投资和咨询意见。产品净值及其收益存在涨跌可能，过往的产品业绩数据并不预示产品未来的业绩表现。本网站所提供的资料并非投资建议或咨询意见，投资者不应依赖本网站所提供的信息及资料作出投资决策。 <br>
          与本网站所载信息及资料有关的所有版权、专利权、知识产权及其他产权均为本公司所有。本公司概不向浏览该资料人士发出、转让或以任何方式转移任何种类的权利。<br>
          <el-button class="know" type="primary" round @click="centerDialogVisible = false">接受</el-button>
          <el-button round @click="down" >放弃</el-button>
        </span>
    </el-dialog>
  </el-container>
</template>
<script>
  export default {
    name: 'main_mobile',
    data() {
      return {
        drawer: false,
        centerDialogVisible: true,
      };
    },
    methods: {
      tabClk(doc) {
        document.querySelector(doc).scrollIntoView({
          behavior: "smooth"
        });
        this.drawer = false;
      },
      copyClick() {
        window.open("http://beian.miit.gov.cn/", '_blank');
      },
      login(){
        window.open("https://xinhong.starunique.net/passport/login", "_self");
      },
      toPiLouPage(){
        window.open("http://02549.zscms.stonescloud.com/mobile_cms/login?redirect=%2Fmobile_cms%2Fhold%2Findex", "_self");
      },
      down(){
        this.centerDialogVisible = false;
        let that = this;
        setTimeout(function () {
          that.$nextTick(()=>{
            that.centerDialogVisible = true;
          })

        },500)
      },
    }
  };

</script>

<style scoped >
  .solid {
    font-size: 12px;
    color: #333333;
    margin-top: 10px;
  }
  .start {
    background-image: url("../../static/images/banner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    text-align: left;
    padding: 30px;
    margin-top: 50px;
  }

  >>> .el-drawer {
    background-color: black;
    color: #ffffff;
  }

  >>> .el-drawer__body {
    font-size: 14px;
  }

  >>> .el-dialog--center {
    height: 50%;
  }

  >>> .el-dialog__body {
    height: 75%;
    overflow: auto;
  }

  .title{
    font-size: 16px;
    font-weight: 600;
    color: #003F75;
  }


  .logo {
    width: 80%;
  }


  >>> .el-button:hover {
    background-color: #FFFFFF;
  }


  >>> .el-button.is-round {
    padding: 12px 40px;
  }

  .philosophy {
    background-image: url("../../static/images/philosophy_bg_phone.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    vertical-align: middle;
  }

  .end {
    background-image: url("../../static/images/pursing.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 260px;
    text-align: center;
    margin-top: 20px;
    vertical-align: middle;
  }


  .drawer_line {
    border-bottom: 1px solid #ffffff ;
    margin: 0;
    line-height: 40px;
  }

  >>> .el-main {
    padding: 0px;
    margin: 0px;
    overflow: auto;
  }

  .el-col a {
    margin-left: 10px;
  }

  .know {
    margin-top: 20px;
    margin-left: 5%;
  }

</style>



// WEBPACK FOOTER //
// src/views/main_mobile.vue